module.exports = __webpack_public_path__ + "img/telegram.7e7271d2.svg";